import { createAction } from '@reduxjs/toolkit';

export const moreGamesUpdate = createAction('moreGamesUpdate');
